// formata data para o padrão dd/mm/yyyy
export function dateFormat(data, locale = 'pt-BR') {
  if (!data) {
    return '';
  }
  return data.toLocaleDateString(locale);
}
